<div>
  <h1>{{data.title}}</h1>
  <h5 *ngIf="data.subTitle" [innerHTML]="data.subTitle"></h5>
  <label *ngIf="data.checkbox"><input type="checkbox" [(ngModel)]="isChecked">{{data.checkbox}}</label>
</div>
<div style="display: flex; flex-direction: row; gap: 30px; justify-content: center; align-items: center; margin-top: 10px">
  <button mat-raised-button (click)="onClose();data.confirm(this.isChecked)">{{data.yes}}</button>
  <button mat-raised-button (click)="onClose();data.cancel()">{{data.no}}</button>
  <button mat-raised-button (click)="onClose()" *ngIf="data.close">{{data.close}}</button>
</div>
